import Svg from "./figs/Svg";
import { useLocation, useNavigate } from "react-router";

export default function ButtomHome() {
  const path = useLocation();
  const navigate = useNavigate();
  const showInPath = [];
  const noShowInPath = [
    "/",
    "/welcome",
    "/userVerify",
    "/resetPassword",
    "/createPassword",
  ];
  return (
    <button
      hidden={noShowInPath.includes(path.pathname)}
      onClick={() => {
        navigate("/welcome");
      }}
      className="fixed top-4 left-4 max-w-[48px] z-[100]"
    >
      <Svg iconName="home" className="w-full h-full" />
    </button>
  );
}
